const items = {
  group: "group",
  "group.fields.name.label": "group name",
  "group.files": "files",
  "group.member": "members",
};

export default items;
